import { ActionName } from '../action-names';
import { SherlockDrawerTabKey } from '../sherlockDrawerTabKey';
import { MainAction } from './mainAction';

export enum TranslationMap {
  AdditionalReview = 'additionalReview'
}

export type Properties = {
  translation: TranslationMap;
  shouldPassOnWeakFlows: boolean;
  showIssuesTable: boolean;
  viewName: string;
};

export type FailedLogic = {
  failReason: string;
  mainAction: MainAction;
  secondAction: ActionName | SherlockDrawerTabKey | undefined;
  properties?: Properties;
};

export type FailureSummary = {
  paymentId: string;
  organizationId: number;
  failedLogics: FailedLogic[] | null;
};
